export function heroTextCarousel() {
	const carousels = document.querySelectorAll('.js-hero-text-carousel');

	if (!carousels.length) {
		return;
	}

	carousels.forEach((carousel) => {
		if (carousel.dataset.carouselInitialized === 'true') {
			return;
		}

		carousel.dataset.carouselInitialized = 'true';

		const slides = Array.from(carousel.querySelectorAll('.hero-text-carousel__slide'));

		if (slides.length <= 1) {
			return;
		}

		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return;
		}

		const intervalFromData = Number(carousel.getAttribute('data-carousel-interval'));
		const autoplayInterval = Number.isFinite(intervalFromData) && intervalFromData >= 2500
			? intervalFromData
			: 4200;

		const splitWordRisePreservingMarkup = (target, delayStep = 55) => {
			const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT, {
				acceptNode(node) {
					if (!node.nodeValue || !node.nodeValue.trim()) {
						return NodeFilter.FILTER_REJECT;
					}
					return NodeFilter.FILTER_ACCEPT;
				}
			});

			const textNodes = [];
			let textNode = walker.nextNode();
			while (textNode) {
				textNodes.push(textNode);
				textNode = walker.nextNode();
			}

			let wordIndex = 0;
			textNodes.forEach((node) => {
				const source = node.nodeValue || '';
				const parts = source.split(/(\s+)/);
				const fragment = document.createDocumentFragment();

				parts.forEach((part) => {
					if (!part) return;

					if (/^\s+$/.test(part)) {
						fragment.appendChild(document.createTextNode(part));
						return;
					}

					const span = document.createElement('span');
					span.className = 'word-rise-word';
					span.style.transitionDelay = `${wordIndex * delayStep}ms`;
					span.textContent = part;
					fragment.appendChild(span);
					wordIndex++;
				});

				if (node.parentNode) {
					node.parentNode.replaceChild(fragment, node);
				}
			});
		};

		const restartSlideWordRise = (slide) => {
			const title = slide.querySelector('.hero-text-carousel__title.animate-word-rise');
			if (!(title instanceof HTMLElement)) {
				return;
			}

			if (!title.dataset.carouselWordRiseOriginalHtml) {
				title.dataset.carouselWordRiseOriginalHtml = title.innerHTML;
			}

			title.classList.remove('in-view');
			title.innerHTML = title.dataset.carouselWordRiseOriginalHtml;
			splitWordRisePreservingMarkup(title, 55);

			window.requestAnimationFrame(() => {
				window.requestAnimationFrame(() => {
					title.classList.add('in-view');
				});
			});
		};

		let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
		let isTransitioning = false;
		let autoplayTimer = null;

		if (activeIndex < 0) {
			activeIndex = 0;
			slides[0].classList.add('is-active');
		}

		const syncHeight = () => {
			let maxHeight = 0;

			slides.forEach((slide) => {
				const previousDisplay = slide.style.display;
				const previousPosition = slide.style.position;
				const previousVisibility = slide.style.visibility;
				const previousInset = slide.style.inset;

				slide.style.display = 'block';
				slide.style.position = 'static';
				slide.style.visibility = 'hidden';
				slide.style.inset = 'auto';

				maxHeight = Math.max(maxHeight, slide.offsetHeight);

				slide.style.display = previousDisplay;
				slide.style.position = previousPosition;
				slide.style.visibility = previousVisibility;
				slide.style.inset = previousInset;
			});

			carousel.style.setProperty('--hero-carousel-height', `${maxHeight}px`);
		};

		const setActiveSlide = (nextIndex) => {
			if (isTransitioning || nextIndex === activeIndex) {
				return;
			}

			const currentSlide = slides[activeIndex];
			const nextSlide = slides[nextIndex];

			isTransitioning = true;

			currentSlide.classList.remove('is-active');
			currentSlide.classList.add('is-leaving');
			currentSlide.setAttribute('aria-hidden', 'true');

			nextSlide.classList.remove('is-leaving');
			nextSlide.classList.add('is-active');
			nextSlide.setAttribute('aria-hidden', 'false');
			restartSlideWordRise(nextSlide);

			window.setTimeout(() => {
				currentSlide.classList.remove('is-leaving');
				isTransitioning = false;
			}, 1100);

			activeIndex = nextIndex;
		};

		const startAutoplay = () => {
			if (autoplayTimer) {
				return;
			}

			autoplayTimer = window.setInterval(() => {
				if (!carousel.classList.contains('is-playing')) {
					carousel.classList.add('is-playing');
				}

				const nextIndex = (activeIndex + 1) % slides.length;
				setActiveSlide(nextIndex);
			}, autoplayInterval);
		};

		const stopAutoplay = () => {
			if (!autoplayTimer) {
				return;
			}

			window.clearInterval(autoplayTimer);
			autoplayTimer = null;
		};

		slides.forEach((slide, index) => {
			slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
		});

		syncHeight();
		carousel.classList.add('is-enhanced');
		restartSlideWordRise(slides[activeIndex]);
		startAutoplay();

		window.addEventListener('resize', syncHeight);

		document.addEventListener('visibilitychange', () => {
			if (document.hidden) {
				stopAutoplay();
			} else {
				startAutoplay();
			}
		});
	});
}
